import { render, staticRenderFns } from "./forkLiftPerson.vue?vue&type=template&id=2de65648"
import script from "./forkLiftPerson.vue?vue&type=script&lang=js"
export * from "./forkLiftPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de65648')) {
      api.createRecord('2de65648', component.options)
    } else {
      api.reload('2de65648', component.options)
    }
    module.hot.accept("./forkLiftPerson.vue?vue&type=template&id=2de65648", function () {
      api.rerender('2de65648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/heq/forkLiftPerson.vue"
export default component.exports